<script>
export default {
    name: 'Breadcrumbs',
    props: {
        defaultReferringPageTitle: String,
        defaultReferringPageUrl: String
    },
    data () {
        return {
            isLoaded: false,
            hashedReferringPageTitle: '',
            hashedReferringPageUrl: ''
        }
    },
    computed: {
        referringPageTitle () {
            if (!this.isLoaded) return '';
            return this.hashedReferringPageTitle || this.defaultReferringPageTitle || '';
        },
        referringPageUrl () {
            if (!this.isLoaded) return '';
            return this.hashedReferringPageUrl || this.defaultReferringPageUrl || '';
        }
    },
    mounted () {
        let hash = window.location.hash;

        if (!hash) {
            this.isLoaded = true;
            return;
        }

        try {
            const urlParams = new URLSearchParams(hash.substring(1));
            this.hashedReferringPageTitle = urlParams.get('referring_page_title') || '';
            this.hashedReferringPageUrl = urlParams.get('referring_page_url') || '';

            // remove hash
            history.replaceState('', document.title, window.location.pathname + window.location.search);

            // add hash params to other links on this page that should share the
            // same referring page
            const $links = document.querySelectorAll('a[href][data-possible-breadcrumb-titles]');
            $links.forEach($link => {
                const linkPossibleTitles = $link.getAttribute('data-possible-breadcrumb-titles')?.split('|').map(title => {
                    const params = new URLSearchParams('title=' + title);
                    return params.get('title');
                })?.filter(title => !!title) || [];

                const isAddHash = linkPossibleTitles.includes(this.hashedReferringPageTitle);
                const doesntAlreadyHaveHash = !$link.href.includes('#');

                // console.log(this.hashedReferringPageTitle, linkPossibleTitles, isAddHash)

                if (isAddHash && doesntAlreadyHaveHash) {
                    $link.href += hash;
                }

            });
        } catch(error) {
            console.log(error);
        }

        this.isLoaded = true;
    }
};
</script>